module.exports = __webpack_public_path__ + "static/media/Restrooms-c.1679cc0b.webp";